<template>
  <b-modal
    ref="modalDetalhamentoOportunidade"
    size="xl"
    no-close-on-background
    hide-footer
    :dialog-class="'alteracao-tamanho'"
    :modal-class="'center-modal'"
  >
    <section name="header">
      <div
        style="display: flex; justify-content: space-between; align-items: center;"
      >
        <h3>
          <font-awesome-icon
            :icon="faFolderOpen"
            class="mr-2"
          />
          #{{ oportunidade.id }} - {{
            oportunidade.empresa
              ? oportunidade.empresa + (oportunidade.empresaCnpj ? ` (${oportunidade.empresaCnpj})` : '')
              : oportunidade.cliente || 'Não informado'
          }}
        </h3>

        <div
          class="header-actions"
          style="display: flex; align-items: center;"
        >
          <cadastro-proposta
            ref="cadastroProposta"
            class="mr-1"
            :empresa-inicial="empresaInicialParaProposta"
            :pessoa-inicial="pessoaInicialParaProposta"
            :deal-id="oportunidade.id"
            :proposta-id-atual="propostaIdAtual"
            @fechar-proposta="propostaIdAtual = null"
          />
          <p class="status mb-0">
            <font-awesome-icon
              :icon="faInfoCircle"
              class="mr-1"
            />
            {{ oportunidade.status }}
          </p>
        </div>
      </div>
    </section>

    <hr>

    <div class="detalhe-modal">
      <aside class="painel-info">
        <div class="info-header">
          <h5 class="mb-0">
            Detalhes
          </h5>
        </div>

        <ul class="info-list">
          <li class="info-item">
            <font-awesome-icon
              :icon="faBuilding"
              class="info-icon"
            />
            <div class="info-content">
              <span class="info-label">Empresa</span>
              <span class="info-value">
                {{
                  oportunidade.empresa
                    ? oportunidade.empresa + (oportunidade.empresaCnpj ? ` (${oportunidade.empresaCnpj})` : '')
                    : 'Não informado'
                }}
              </span>
            </div>
          </li>

          <li class="info-item">
            <font-awesome-icon
              :icon="faClipboardList"
              class="info-icon"
            />
            <div class="info-content">
              <span class="info-label">Pacote de serviço</span>
              <input
                v-model="empresaLivres.pacoteServicos"
                class="empresa-inline-input empresa-inline-input--lateral"
                type="text"
                placeholder="Não informado"
                @blur="salvarCampoLivre('pacoteServicos')"
              >
            </div>
          </li>

          <li class="info-item">
            <font-awesome-icon
              :icon="faMoneyBillWave"
              class="info-icon"
            />
            <div class="info-content">
              <span class="info-label">Honorários</span>
              <span class="info-value">Não informado</span>
            </div>
          </li>
        </ul>
      </aside>

      <div class="painel-conteudo">
        <div class="empresa-info-wrapper">
          <div class="empresa-info-grid empresa-info-grid-top">
            <div class="empresa-info-item">
              <div class="empresa-info-label">
                Enquadramento:
              </div>
              <div class="empresa-info-value">
                {{ enquadramentoExibicao }}
              </div>
            </div>

            <div class="empresa-info-item">
              <div class="empresa-info-label">
                Porte
              </div>

              <input
                v-model="empresaLivres.porte"
                class="empresa-inline-input"
                type="text"
                placeholder="Não informado"
                @blur="salvarCampoLivre('porte')"
              >
            </div>

            <div class="empresa-info-item">
              <div class="empresa-info-label">
                CNAE Principal
              </div>
              <div class="empresa-info-value empresa-info-wrap">
                {{ cnaeExibicao }}
              </div>
            </div>
          </div>
        </div>

        <b-tabs
          pills
          card
          class="abas"
        >
          <b-tab
            title="Geral"
            active
          >
            <aba-geral-oportunidade :deal="oportunidade" />
          </b-tab>

          <b-tab title="Atividade">
            <aba-atividade-oportunidade :deal-id="oportunidade.id" />
          </b-tab>

          <b-tab title="Proposta">
            <propostas-tabela
              :oportunidade-id="oportunidade.id"
              @detalhar-proposta="abrirModalProposta"
            />
          </b-tab>

          <b-tab title="Documentos">
            <documentos-oportunidade
              :deal-id="oportunidade.id"
              :pode-deletar="true"
            />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </b-modal>
</template>
<script>
import {
  faPlus,
  faArrowsAlt,
  faArrowUp,
  faInfoCircle,
  faFolderOpen,
  faBuilding,
  faMoneyBillWave,
  faUser,
  faCalendarAlt,
  faClipboardList,
  faPen,
  faTimes,
  faSave,
  faClock,
  faBell,
  faCopy,
} from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/comercial/oportunidades/shared/services/api'
import empresaApi from '@/app-modulo/comuns/empresa/shared/services/api'

export default {
  name: 'ModalDetalhesOportunidade',

  components: {
    FontAwesomeIcon: () => import('@fortawesome/vue-fontawesome'),
    AbaGeralOportunidade: () => import('@/app-modulo/comercial/oportunidades/shared/components/aba-geral-oportunidade/AbaGeralOportunidade.vue'),
    AbaAtividadeOportunidade: () => import('@/app-modulo/comercial/oportunidades/shared/components/aba-atividades-oportunidade/AbaAtividadeOportunidade.vue'),
    CadastroProposta: () => import('@/app-modulo/comercial/cadastro-proposta/CadastroProposta.vue'),
    PropostasTabela: () => import('@/shared/components/propostas-tabela/PropostasTabela.vue'),
    DocumentosOportunidade: () => import('@/shared/components/documentos-oportunidade/DocumentosOportunidade.vue'),
  },
  props: {
    oportunidadeId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      faPlus,
      faArrowsAlt,
      faArrowUp,
      faInfoCircle,
      faFolderOpen,
      faBuilding,
      faMoneyBillWave,
      faUser,
      faCalendarAlt,
      faClipboardList,
      faPen,
      faTimes,
      faSave,
      faClock,
      faBell,
      faCopy,

      propostaIdAtual: null,
      empresaCadastro: null,
      carregandoEmpresaCadastro: false,
      oportunidade: this.novaOportunidadeBase(),

      empresaLivres: {
        porte: '',
        pacoteServicos: '',
        equipeResponsavel: '',
        honorariosTipo: '',
        honorariosValor: '',
      },
    }
  },
  computed: {
    empresaInicialParaProposta() {
      if (!this.oportunidade || !this.oportunidade.companyId) return null
      return {
        id: this.oportunidade.companyId,
        razaoSocial: this.oportunidade.empresa || '',
        cadastroFederal: this.oportunidade.empresaCnpj || '',
        pessoaPreferidaId: this.oportunidade.personId || null,
      }
    },
    pessoaInicialParaProposta() {
      if (!this.oportunidade || !this.oportunidade.personId) return null
      return {
        id: this.oportunidade.personId,
        nome: this.oportunidade.cliente || '',
      }
    },
    enquadramentoExibicao() {
      const val = this.extrairEnquadramento(this.empresaCadastro)
      return val || 'Não informado'
    },
    cnaeExibicao() {
      const val = this.extrairCnaePrincipal(this.empresaCadastro)
      return val || 'Não informado'
    },

    empresaHeaderNome() {
      const opp = this.oportunidade || {}

      if (!opp.companyId) {
        if (opp.empresa) return opp.empresa
        if (opp.titulo) return opp.titulo
        return 'Empresa não informada'
      }

      if (this.carregandoEmpresaCadastro) return 'Carregando...'

      const emp = this.empresaCadastro || {}
      return emp.razaoSocial || emp.nomeFantasia || emp.nome || opp.empresa || 'Empresa não encontrada'
    },

    empresaHeaderCnpjRaw() {
      if (!this.oportunidade || !this.oportunidade.companyId) return ''
      if (this.carregandoEmpresaCadastro) return ''
      const emp = this.empresaCadastro || {}
      return emp.cadastroFederal || emp.cnpj || this.oportunidade.empresaCnpj || ''
    },
    empresaHeaderCnpjLabel() {
      const cnpj = this.empresaHeaderCnpjRaw
      return cnpj ? `CNPJ: ${cnpj}` : 'CNPJ não informado'
    },

    empresaHeaderEnderecoRaw() {
      if (!this.oportunidade || !this.oportunidade.companyId) return ''
      if (this.carregandoEmpresaCadastro) return ''
      return this.formatarEnderecoEmpresa(this.empresaCadastro) || ''
    },
    empresaHeaderEnderecoMapsUrl() {
      const endereco = this.empresaHeaderEnderecoRaw
      if (!endereco) return ''
      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(endereco)}`
    },
  },
  watch: {
    'novaOportunidade.company': 'onNovaOportunidadeCompanyChanged',
  },
  created() {
    // prefer route param if present, otherwise keep incoming prop value
    const routeId = Number(this.$route && this.$route.params && this.$route.params.oportunidadeId) || null
    if (routeId) {
      api.getDealById(routeId).then(response => {
        const deal = response.data
        this.oportunidade = {
          titulo: deal.title,
          id: deal.id,
          cliente: deal.personName || null,
          personId: deal.personId || null,
          empresa: deal.companyName || null,
          companyId: deal.companyId || null,
          empresaCnpj: deal.companyCnpj || null,
          valor: deal.estimatedValue,
          status: deal.status,
          responsavel: deal.ownerName || 'Não definido',
          prazo: deal.expectedCloseDate,
          cadastro: deal.dataCadastro || null,
          respCadastro: deal.usuCadastro || 'Sistema',
        }
        this.showModal()
      })
    }
  },
  methods: {
    salvarCampoLivre(chave) {
      const v = this.empresaLivres[chave]
      if (typeof v === 'string') {
        this.empresaLivres[chave] = v.trim()
      }
      if (this.$sucesso) this.$sucesso('Salvo!')
    },
    showModal() {
      if (this.oportunidadeId) {
        api.getDealById(this.oportunidadeId).then(response => {
          const deal = response.data
          this.oportunidade = {
            titulo: deal.title,
            id: deal.id,
            cliente: deal.personName || null,
            personId: deal.personId || null,
            empresa: deal.companyName || null,
            companyId: deal.companyId || null,
            empresaCnpj: deal.companyCnpj || null,
            valor: deal.estimatedValue,
            status: deal.status,
            responsavel: deal.ownerName || 'Não definido',
            prazo: deal.expectedCloseDate,
            cadastro: deal.dataCadastro || null,
            respCadastro: deal.usuCadastro || 'Sistema',
          }
          this.carregarEmpresaCadastro(this.oportunidade.companyId)
          this.$refs.modalDetalhamentoOportunidade.show()
        })
        return
      }
      if (!this.oportunidade) return

      this.carregarEmpresaCadastro(this.oportunidade.companyId)
      this.$refs.modalDetalhamentoOportunidade.show()
    },
    abrirModalProposta(proposta) {
      this.propostaIdAtual = proposta.id
      this.$refs.cadastroProposta.showModal()
    },
    onNovaOportunidadeCompanyChanged(novaEmpresa, empresaAnterior) {
      const novoId = novaEmpresa && novaEmpresa.id
      const anteriorId = empresaAnterior && empresaAnterior.id
      if (novoId !== anteriorId) {
        this.novaOportunidade.person = null
      }
    },

    hidratarCamposLivresDoCadastro(empresa) {
      if (!empresa) return
      const porteDoCadastro = empresa.porte
        || empresa.porteEmpresa
        || empresa.tamanho
        || ''
      if (!this.empresaLivres.porte) this.empresaLivres.porte = porteDoCadastro || ''
    },

    extrairCnaePrincipal(empresa) {
      if (!empresa) return ''

      const c = empresa.cnaePrincipal
        || empresa.cnae
        || (empresa.cnaePrincipalObj || null)
        || (empresa.cnaePrincipal && empresa.cnaePrincipal.descricao ? empresa.cnaePrincipal : null)

      if (typeof c === 'string') return c.trim()

      if (c && typeof c === 'object') {
        const codigo = c.codigo || c.code || c.id || ''
        const desc = c.descricao || c.description || c.nome || ''
        return [codigo, desc].filter(Boolean).join(' - ').trim()
      }

      const codigo = empresa.cnaePrincipalCodigo || empresa.cnaeCodigo || ''
      const desc = empresa.cnaePrincipalDescricao || empresa.cnaeDescricao || ''
      return [codigo, desc].filter(Boolean).join(' - ').trim()
    },

    extrairEnquadramento(empresa) {
      if (!empresa) return ''

      const base = empresa.cadastro || empresa.dadosCadastrais || empresa

      const v = base.enquadramento
        || base.enquadramentoFiscal
        || base.enquadramentoTributario
        || base.regimeTributario
        || base.regime
        || base.regimeDeTributacao
        || base.tipoEnquadramento
        || ''

      if (v && typeof v === 'object') {
        const desc = v.descricao || v.description || v.nome || ''
        return typeof desc === 'string' ? desc.trim() : ''
      }

      return typeof v === 'string' ? v.trim() : ''
    },

    async copiarCnpj() {
      const texto = this.empresaHeaderCnpjRaw
      if (!texto) return
      await this.copiarTexto(texto, 'CNPJ copiado!')
    },

    async copiarTexto(texto, msgSucesso = 'Copiado!') {
      if (!texto) return
      try {
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(texto)
        } else {
          const textarea = document.createElement('textarea')
          textarea.value = texto
          textarea.setAttribute('readonly', '')
          textarea.style.position = 'absolute'
          textarea.style.left = '-9999px'
          document.body.appendChild(textarea)
          textarea.select()
          document.execCommand('copy')
          document.body.removeChild(textarea)
        }
        if (this.$sucesso) this.$sucesso(msgSucesso)
      } catch (e) {
        if (this.$erro) this.$erro('Não foi possível copiar.')
      }
    },

    async carregarEmpresaCadastro(empresaId) {
      this.empresaCadastro = null
      if (!empresaId) return
      this.carregandoEmpresaCadastro = true
      try {
        const response = await empresaApi.getEmpresa(empresaId)
        this.empresaCadastro = response && response.data ? response.data : null
        this.hidratarCamposLivresDoCadastro(this.empresaCadastro)
      } catch (error) {
        this.empresaCadastro = null
      } finally {
        this.carregandoEmpresaCadastro = false
      }
    },
    novaOportunidadeBase() {
      return {
        title: '',
        estimatedValue: 0,
        companyId: 0,
        personId: 0,
        pipelineId: null,
        company: null,
        person: null,
      }
    },
    formatarEnderecoEmpresa(empresa) {
      if (!empresa) return ''
      const e = empresa.endereco || empresa.address || null
      if (!e) return ''

      const ufSigla = (e.uf && e.uf.sigla) ? e.uf.sigla : (e.ufSigla || e.uf || '')
      const logradouro = e.logradouro || e.rua || e.street || ''
      const numero = e.numero || e.number || ''
      const complemento = e.complemento || e.complement || ''
      const bairro = e.bairro || e.district || ''
      const cidade = e.cidade || (e.municipio && (e.municipio.nome || e.municipio)) || e.city || ''
      const cep = e.cep || e.zip || e.postalCode || ''

      const parteRua = [logradouro, numero].filter(Boolean).join(', ')
      const linha1 = [parteRua, complemento].filter(Boolean).join(' ')
      const parteCidadeUf = [cidade, ufSigla].filter(Boolean).join('/')
      const linha2 = [bairro, parteCidadeUf, (cep ? `CEP ${cep}` : '')].filter(Boolean).join(' - ')

      return [linha1, linha2].filter(Boolean).join(' - ')
    },
  },
}
</script>
